

















import RealtimeCard from './realtime-card.vue'

import { GetLastRecord } from '@/api/collector'
import { FindStacks, Stack } from '@/api/cems'

import Vue from 'vue'

export default Vue.extend({
  name: 'Home',
  components: {
    RealtimeCard,
  },
  data() {
    return {
      groupId: 1,
      // eslint-disable-next-line
      tmrCyclicUpdate: undefined as any,
      quit: false,
      stacks: [] as Stack[],
      // eslint-disable-next-line
      lastValue: {} as { [stackId: number]: any },
      groups: {
        '1': {
          1: {
            title: 'ENGINE 1',
            subtitle: 'ENGINE 1',
            data: {},
          },
          2: {
            title: 'ENGINE 2',
            subtitle: 'ENGINE 2',
            data: {},
          },
          3: {
            title: 'ENGINE 3',
            subtitle: 'ENGINE 3',
            data: {},
          },
          4: {
            title: 'ENGINE 4',
            subtitle: 'ENGINE 4',
            data: {},
          },
          5: {
            title: 'ENGINE 5',
            subtitle: 'ENGINE 5',
            data: {},
          },
          6: {
            title: 'ENGINE 6',
            subtitle: 'ENGINE 6',
            data: {},
          },
        },
        '2': {
          7: {
            title: 'ENGINE 7',
            subtitle: 'ENGINE 7',
            data: {},
          },
          8: {
            title: 'ENGINE 8',
            subtitle: 'ENGINE 8',
            data: {},
          },
          9: {
            title: 'ENGINE 9',
            subtitle: 'ENGINE 9',
            data: {},
          },
          10: {
            title: 'ENGINE 10',
            subtitle: 'ENGINE 10',
            data: {},
          },
          11: {
            title: 'ENGINE 11',
            subtitle: 'ENGINE 11',
            data: {},
          },
          12: {
            title: 'ENGINE 12',
            subtitle: 'ENGINE 12',
            data: {},
          },
        },
        // eslint-disable-next-line
      } as any,
    }
  },

  methods: {
    async FindStack() {
      this.stacks = await FindStacks()
    },
    async getLastRecord() {
      const ids = this.stacks.map((stack) => stack.id)
      this.lastValue = await GetLastRecord(ids)
      // for (const i in ids) {
      //   const groupKey = ids[i]
      //   const lastValue = lastValues[groupKey.toString()]
      //   this.groups[this.groupId][groupKey].data = lastValue
      // }
    },

    async cyclicUpdate() {
      await this.getLastRecord()
      this.tmrCyclicUpdate = setTimeout(() => {
        if (this.quit) {
          return
        }
        this.cyclicUpdate()
      }, 5000)
    },
  },

  watch: {
    '$route.params.id': function(val: string) {
      this.groupId = parseInt(val)
      this.getLastRecord()
    },
  },

  async created() {
    await this.FindStack()
    this.groupId = parseInt(this.$route.params.id)
    this.cyclicUpdate()
  },

  beforeDestroy() {
    clearTimeout(this.tmrCyclicUpdate)
    this.quit = true
  },
})
